import React, { Component, Fragment } from 'react';
import withRouter from '../../withRouter';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import moment from 'moment';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import PurchaseOrderForm from './projectTracker/PurchaseOrderForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LZString from 'lz-string';
import CreateProjectDialog from '../pages/projectTracker/AddVendor';
import { Navigate } from 'react-router-dom';

class PurchaseOrder extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    let userID = userInfo['userId'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();

    let vendorInfo = JSON.parse(localStorage.getItem('vendor'));
    let projectName = JSON.parse(localStorage.getItem('projectName'));

    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];
    //let title = this.props.match.params.slug;
    let title = this.props.location.state.title;
    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: title,
      data: [],
      redirect: null,
      alert: '',
      incType: '',
      isFlushed: false,
      //storeValue: stores[0].storeId,
      storeValue: '',
      storeSelected: false,
      closure: '',
      stores,
      userID: userID,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],

      vendorInfo: vendorInfo,
      projectName: projectName,
      submittedByCodeJson: [],
      message: 'ssssd',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      submittedBy: '',
    };
  }
  goBack = () => {
    this.setState({
      redirect: '/projectTracker',
    });
  };

  submitHandler = (data) => {
    let utc = 'T00:00:00.000Z';
    //alert(JSON.stringify(data.total.freightCharge));
    const arM = data.products.filter(
      (item) => item.description !== '' && item.qty !== 0
    );
    let poDate = new Date().toISOString();

    let category = [];
    let some = arM.map((index) => {
      let temp = {};
      temp['gstAmount'] = index.gstAmount;
      temp['gstPercentage'] = index.gst;
      temp['itemAmount'] = index.amount;
      temp['itemDesc'] = index.description;
      temp['itemQuantity'] = index.qty;
      temp['itemRate'] = index.rate;
      temp['itemUnit'] = index.unit;
      // temp["poNo"] = data.total.poNo;
      temp['poNo'] = '';
      temp['storeId'] = this.state.vendorInfo.storeId;
      temp['totalAmount'] = index.totalAmount;
      category.push(temp);
    });

    //alert(JSON.stringify(category));

    let generateValue = {
      decContactPerson: data.total.decathlonContactPerson,
      deliveryDate: data.total.deliverDate + utc,
      grandTotal: data.total.grandTotal,
      gstAmount: data.total.gstTotal,
      freightAmount: data.total.freightCharge,
      installationDate: data.total.installationDate + utc,
      paymentTerms: data.total.terms,
      poCreatedBy: this.state.userID,
      poDate: poDate,
      poDetails: category,
      poNo: '',
      projectId: this.state.vendorInfo.projectId,
      storeId: this.state.vendorInfo.storeId,
      subTotal: data.total.subTotal,
    };
    this.setState({
      loading: true,
    });

    if (generateValue.poDetails.length > 0) {
      // alert(JSON.stringify(generateValue.poDetails));
      // setTimeout(() => {
      //   window.location.reload();
      // }, 4000);

      ApiGateWay.Post(this.state.apiInterface + '/generatePO', generateValue)
        .then((response) => response.json())
        .then((response) => {
          this.setState({
            loading: false,
            statusEditing: false,
          });

          //alert(JSON.stringify(response));
          toast.success('PO Generated Successfully!');
          //this.onLoadVendors();
          setTimeout(() => {
            this.setState({
              redirect: '/projectTracker',
            });
            
          }, 4000);
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later!!',
          });
        });
    } else {
      this.setState({
        loading: false,
        modalOpen: true,
        message: 'Please fill all the product details',
      });
      // setTimeout(() => {
      //   window.location.reload();
      // }, 4000);
    }

    // alert(JSON.stringify(generateValue));
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    if (this.props.location.setReload) {
      //window.location.reload();
    }
    ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        this.setState({
          submittedByCodeJson: response,
          visible: true,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }

  render() {
    const { loading, modalOpen, message, vendorInfo, projectName } = this.state;

    //alert(vendorInfo);
    if (this.state.redirect) {
      return (
        <Navigate
          to={{
            pathname: this.state.redirect,
          }}
        />
      );
    }
    return (
      <>
        <Helmet>
          <title>{`Purchase Order - ${this.state.title}`}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />

          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content' style={{ width: '95%' }}>
                <div className='row '>
                  <div className='row'>
                    <div
                      className='col-md-12 '
                      style={{ backgroundColor: '#eaf7fdcc' }}
                    >
                      <ToastContainer
                        position='top-right'
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        className=''
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                      />{' '}
                      <button
                        type='button'
                        className='btn btn-secondary deca-btn-orange'
                        onClick={this.goBack}
                        style={{
                          cursor: 'pointer',
                          display: 'relative',
                          backgroundColor: 'none',
                        }}
                      >
                        <i className='fa fa-arrow-left' aria-hidden='true'></i>
                      </button>
                      <div>
                        <PurchaseOrderForm
                          submitHandler={this.submitHandler}
                          vendorInfo={vendorInfo}
                          projectName={projectName}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default withRouter(PurchaseOrder);
